export const columns = [
  { title: 'Entity', key: 'entity', width: 20, keySort: 'entity' },
  { title: 'Household', key: 'family', width: 12, keySort: 'household' },
  { title: 'Overall Capacity', key: 'overallCapacity', width: 10, keySort: 'overall capacity' },
  { title: 'Asset Class Capacity', key: 'assetClassCapacity', width: 10, keySort: 'asset class capacity' },
  { title: 'Criteria', key: 'suitability', width: 18, keySort: 'criteria' },
  { title: 'Amount', key: 'amount', width: 10, keySort: 'amount' },
  { title: 'Decision', key: 'decision', width: 14, keySort: 'decision' },
  { title: '', width: 4, key: 'key' }
];

export const initialFilterBarValues = [
  {
    type: 'allocationStatus',
    name: 'Initial Allocation',
    value: 'initialAllocation',
    enabled: true
  },
  {
    type: 'allocationStatus',
    name: 'Already Committed',
    value: 'alreadyCommitted',
    enabled: false
  },
  {
    type: 'allocationStatus',
    name: 'Internal Review Rejected',
    value: 'internalReviewRejections',
    enabled: false
  },
  {
    type: 'allocationStatus',
    name: 'Terminated',
    value: 'terminated',
    enabled: false
  }
];
